
export const LogisticsProviderEnum = {
  status: {
    ENABLE: 'enable',
    DISABLE: 'disable',
  },
  statusOption: [
    {id: 'enable', text: '启用'},
    {id: 'disable', text: '停用', color: 'red'},
  ]
};
